import React, {useEffect} from 'react';
import {Route, Switch, useHistory} from "react-router-dom";
import {useRecoilValue} from "recoil";
import {isLoggedInState} from "../state/userState";
import {NavigationDrawer} from "../components/NavigationDrawer";
import Home from "./Home";
import SignIn from "./SignIn";
import ArticlesSentiment from "./ArticlesSentiment";
import ArticlesSentimentV2 from "./ArticlesSentimentV2";
import TweetsSentiment from "./TweetsSentiment";


export default function Layout() {
  const history = useHistory();
  const isLoggedIn = useRecoilValue(isLoggedInState)


  useEffect(() => {
    console.log(isLoggedIn)
    if (isLoggedIn) {
      history.push("/sentiment/en")
    } else {
      history.push("/sign-in")
    }
  }, [isLoggedIn, history])

  return (
    <NavigationDrawer>
      <Switch>
        <Route exact path="/" component={Home}/>
        <Route exact path="/sign-in" component={SignIn}/>
        <Route path="/sentiment/en" component={ArticlesSentiment}/>
        <Route path="/sentiment/ru" component={ArticlesSentimentV2}/>
        <Route path="/sentiment/tweet" component={TweetsSentiment}/>
      </Switch>
    </NavigationDrawer>
  );
}

